import { render } from "./MarketItem.vue?vue&type=template&id=481f5390"
import script from "./MarketItem.vue?vue&type=script&lang=js"
export * from "./MarketItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__